'use strict';

import TWEEN from './libs/tween.umd';
import {BufferGeometry, Clock, Material, Mesh, Vector2} from 'three';
import {CSS2DRenderer} from "./libs/CSS2DRenderer.js";
import {
	getUrlParam,
	lockScreenForTablet,
	userPrevent,
	setParametersDependsOnCanvasArea,
	checkHash,
	updateProjectAPIData,
	isUrlHasParam,
	addWatermark,
	isOptionsCardOpened,
	setSelectionBoxesColors,
	setCSSVar,
	lockScreenOrientation,
	showSoldApartmentsFromCurrentDay,
	isCylinderDisplayModeEqual, getUrlSearchQuery, applyShortBuildingNameRule, getRandomNumber,
} from './functions';
import {
	Buildings,
	cardsData, components,
	isDesktop,
	isMobile,
	isSafari, isWeb,
	projectMode,
	settingsData,
	threeJsVariables, TRoot, UIRoot,
} from './settings';
import {createThreeJsEnvironment, setStats} from "./modules/threejs/threejs-components";
import {getVars} from "./modules/customStyles/customStyles";
import { changeLangToCurrent, langSwitcher } from './modules/components/langSwitcher/langSwitcher';
import {RaycastHandler} from "./modules/controls/mouse-n-touches";
import {moveElements, rightNavigationBar, rightNavMenuZIndexChange} from "./modules/menu/navigation/right-nav-bar";
import {fitModelInViewport} from './modules/controls/zoomControl';
import {
	autoRotateInit,
	autoRotateTimerAction,
	debugOrbitControls,
	orbitControlsInit,
} from './modules/controls/orbitControls';
import {
	setOptionsCardButtonsWidthIntoCssVar, setOptionsCardDataHeightInCssVar,
	setPlansBlockBoundaries,
	setWidthOfCardDependingOnMenu
} from "./modules/cards/optionsCards";
import {
	buildingsLabelResize, mobileBuildingLabelsHideLogic,
} from './modules/components/building-switch/buildingLabels';
import {ViewMode} from "./common";
import {getCurrentLangDirection, setInitialHtmlDirection} from './modules/components/langSwitcher/langSwitcher';
import {setMinAndMaxControlsDistance} from './modules/controls/orbitControls';
import {additionalMenuToggle, getActiveMenuData, menuInit} from './modules/menu/menu';
import {bottomNavBarInit} from './modules/menu/navigation/bottom-nav-bar';
import {compassInit} from './modules/components/compass/compass';
import {
	preloaderSliderInit
} from './modules/components/preloader/preloader';
import {widgetsInit} from './modules/widgets/widgets';
import {
	addPoiWidgetBasicStyle,
	panoramaOrbitResize,
	poiOrientationHandler,
} from './modules/widgets/poi/poiv3';
import {initForm} from "./modules/components/form/form";
import {addGui} from "./modules/gui/gui";
import {trackballControlsInit} from './modules/controls/trackballControls';
import {
	setSearchContainerMaxHeight,
	updateComponentsOnCanvasResize
} from './modules/menu/search/search';
import {cssPoiHandler, resizeOrbitPoiCard} from './modules/poi/poiCss';
import {renderLoop} from "./modules/threejs/environment";
import {createStreetNames} from "./modules/components/street-names/addStreetNames";
import {addPoweredLogo} from './modules/components/poweredLogo/poweredLogo';
import {checkIntersection} from "./modules/threejs/raycast";
import {setWidthOfApplyNow} from "./modules/components/apply-now/applyNow";
import './libs/addToHomeScreen/add-to-homescreen.min.css';
import './libs/addToHomeScreen/add-to-homescreen.min';
import 'multiple-select/dist/multiple-select.min.css';
import 'multiple-select/dist/multiple-select.min';
import '../scss/main-style.scss';
import {getGoogleAnalyticsData} from "./modules/analytics/statistic";
import {UnitCardClass} from "./modules/cards/unitCards/UnitCardClass";
import {chatsInit} from './modules/components/chats/chats';
import {getLordIconColors} from './lordicon';
import {update as cameraUpdate, cameraAnimationActive} from "./modules/threejs/camera";
import {
	animationMixerUpdate
} from './modules/post-processing/post-processing';
import {Pagination} from "./modules/components/pagination/Pagination";
import {Weather} from './modules/components/weather/Weather';
import {CylinderBase} from './modules/cylinderGrid/CylinderBase';
import {DisplayOptions} from "./modules/components/displayOptions/DisplayOptions";
import {PublicLayers} from './modules/components/publicLayers/PublicLayers';
import {Favorite} from './modules/components/Favorite/Favorite';
import {EnvironmentToggle, OSMEnv} from './modules/threejs/sceneBackground';
import {CustomerContactNow} from "./modules/menu/contactUs/CustomerContactNow";
import {BaseElement} from "./modules/interfaces/BaseElement";
import {Vantages} from './modules/components/vantage/Vantage';
import {resizeGallery} from './modules/menu/gallery/galleryDesktop';
import {RenderingLogo} from "./modules/components/poweredLogo/RenderingLogo";
import {recreateBlockWhenLangSwitch} from './modules/menu/search/similarSearch';
import {ScreenLogo} from "./modules/components/ScreenLogo";
import {PushNotifications} from './modules/pushNotifications/PushNotifications';
import {UserAPI} from './modules/api/UserAPI';
import {Banner} from "./modules/components/Banner";
import {VideoPopUp} from "./modules/components/VideoPopUp";
import {Password} from './modules/components/Password/Password';
import {getCommonAssets, getSales, sendLogs} from "./modules/crm/crm-requests";
import {Environment} from './modules/components/Environment/Environment';
import {computeBoundsTree, disposeBoundsTree, acceleratedRaycast} from 'three-mesh-bvh';
import {CameraMarker, ZoomArea} from './modules/MiniMap/MiniMap';
import {ResizeObserver} from 'resize-observer';
import {Cloudflare} from "./modules/api/Cloudflare";
import {GetElement} from "./modules/interfaces/GetElement";
import {ProjectLogs} from "./modules/components/ProjectLogs";
import {analytics} from "./modules/analytics/analytics";
import {Disclaimer} from "./modules/components/Disclaimer/Disclaimer";
import {ConfigInformer} from "./modules/components/ConfigInformer/ConfigInformer";
import { Joystick } from './modules/controls/Joystick';
import {McID} from "./modules/menu/contactUs/McID";
import {getContactsDataFromAPI} from "./modules/menu/contactUs/contactUs";
import {EventBus} from "./modules/interfaces/EventBus";
import { PWA } from './modules/components/PWA';
import { OptionsCardViewer } from './modules/cards/OptionsCardViewer';
import { SkyLineController } from './modules/controls/SkyLineController';
import { BmbyMode } from './modules/mode/BmbyMode';
import {poiIntersection} from './modules/poi/poiCss';
import { SalesPlane } from './modules/threejs/SalesPlane.js';
import { Cluster } from './modules/threejs/Cluster/CSS2DCluster';
import { CssLabelManager } from './modules/components/CssLabelManager/CssLabelManager';
import { PointViewManager } from './modules/components/pointViewManager/PointViewManager';
import { AirMode } from './modules/mode/AirMode';
import { PerformanceAnalyzation } from './modules/threejs/Quality/PerformanceAnalyzation';
import { ConfirmMessage } from './modules/interfaces/ConfirmMessage';

window.onerror = function (message, source, lineno, colno, error) {
	// console.error("Global error caught:", message, source, lineno, colno, error);
	const isPaginationHasLocalhost = Pagination.history.some(item =>
			typeof item === "string" && item.includes("localhost") ||
			typeof item === "object" && Object.values(item).some(value =>
				typeof value === "string" && value.includes("localhost")
			)
	);
	const sourceUrl = typeof source === 'string' ? source : '';
	const isLocalhost = source.split('/').includes('localhost:3100') || isPaginationHasLocalhost;
	const isGoogleBot = /Googlebot\/\d+\.\d+|Google-Read-Aloud/.test(navigator.userAgent);
	if (
		isLocalhost
		|| typeof config === 'undefined' || !Boolean(config)
		|| isGoogleBot
	)
		return;

	const stackTrace = error?.stack ?? 'Stack trace not available';
	sendLogs({
		message,
		source: sourceUrl,
		lineno,
		colno,
		// Include the original error object if needed (can be complex to serialize)
		// error: error, // Be careful sending raw error objects, might not serialize well
		errorMessage: error?.message, // Send just the message from the error object too
		errorName: error?.name,       // Send the type of error (e.g., 'TypeError')
		stackTrace: stackTrace,       // <-- Add the stack trace here
		searchQuery: getUrlSearchQuery(),
		paginationHistory: Pagination.history,
		userAgent: navigator.userAgent,
	}, 'error');
};

// window.addEventListener("unhandledrejection", function (event) {
// 	// console.error("Unhandled rejection:", event.reason);
// 	sendLogs(event.reason, 'error');
// });

BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
Mesh.prototype.raycast = acceleratedRaycast;
Material.prototype.onBeforeCompile = function (shader) {
	if (this.customPrograms && this.customPrograms.length) {
		this.customPrograms.forEach(fn => fn(shader,this));
	}
};

let controls;
let trackballControls;
const password = new Password();
window.tl = new ProjectLogs();
const pwa = new PWA();
pwa.addEvents();


const marketingId = getUrlParam('id');
if (marketingId) {
	config.projectGuid = marketingId;
}

if (settingsData.isConferenceHost) {
	document.body.classList.add('conference-mode');
}

if (BmbyMode.active) {
	document.body.classList.add('bmby-mode','light-theme');
	config.resources.background.cylinderBg = '';
	config.resources.bundle.selectionBoxes.colorStatus = config.resources.bundle.selectionBoxes.colorStatus.concat([
			{
				"status": "for sale",
				"basic": "0d61af",
				"hover": "4BA8FD",
				"active": "0d84f2",
				"isActive": true,
				"opacity": {
					"basic": 0.2,
					"hover": 0.8
				}
			},
			{
				"status": "not for sale",
				"basic": "c60745",
				"hover": "FF4B85",
				"active": "ef0853",
				"isActive": true,
				"opacity": {
					"basic": 0.2,
					"hover": 0.8
				}
			},
			{
				"status": "contract",
				"basic": "59ba41",
				"hover": "34704d",
				"active": "1f3f2d",
				"isActive": true,
				"opacity": {
					"basic": 0.2,
					"hover": 0.8
				}
			},
			{
				"status": "precontract",
				"basic": "EED527",
				"hover": "EED527",
				"active": "EED527",
				"isActive": true,
				"opacity": {
					"basic": 0.2,
					"hover": 0.8
				}
			},
			{
				"status": "rent contract",
				"basic": "C49FFF",
				"hover": "C49FFF",
				"active": "C49FFF",
				"isActive": true,
				"opacity": {
					"basic": 0.2,
					"hover": 0.8
				}
			},
			{
				"status": "registration contract",
				"basic": "37b6b3",
				"hover": "37b6b3",
				"active": "37b6b3",
				"isActive": true,
				"opacity": {
					"basic": 0.2,
					"hover": 0.8
				}
			},
			{
				"status": "reserved",
				"basic": "FDAA05",
				"hover": "FFBB33",
				"active": "F9CF7C",
				"isActive": true,
				"opacity": {
					"basic": 0.2,
					"hover": 0.8
				}
			},
			{
				"status": "occupied",
				"basic": "AAC1CC",
				"hover": "AAC1CC",
				"active": "AAC1CC",
				"isActive": true,
				"opacity": {
					"basic": 0.2,
					"hover": 0.8
				}
			}
		]);
}

new OptionsCardViewer().open()
	.then(() => {
		password.create()
			.then(() => {
				projectMode.AirMode = new AirMode();
				ProjectLogs.timerStartFor('total');
				addGui();
				preloaderSliderInit();
				createThreeJsEnvironment();
				templateResizeFunctionDuringProjectIsLoading();
				controls = orbitControlsInit();
				trackballControls = trackballControlsInit();
				setStats();
				animate();
			});
	});


projectMode.Pagination = new Pagination();
addDocumentProperties();
addPoiWidgetBasicStyle();

const clock = new Clock();
let elapsedTime = 0;

function templateResizeFunctionDuringProjectIsLoading() {
	window.addEventListener('resize', onLoadWindowResize, false);
	window.addEventListener('orientationchange', onLoadWindowResize, false);

	function onLoadWindowResize() {
		if (settingsData.projectLoaded) {
			window.removeEventListener('resize', onLoadWindowResize, false);
			window.removeEventListener('orientationchange', onLoadWindowResize, false);
			return;
		}
		// settingsData.isLandscape = window.matchMedia("(orientation: landscape)").matches;
		checkAndSetScreenOrientation();
		threeJsVariables.perspectiveCamera.aspect = window.innerWidth / window.innerHeight;
		threeJsVariables.perspectiveCamera.updateProjectionMatrix();
		threeJsVariables.renderer.setSize(window.innerWidth, window.innerHeight);
		projectMode.LiteMode?.resizeContainer();
	}
}

export async function startProject(settings = config['crmProjectSettings']) {
	console.log('Start app');
	CustomerContactNow.addExternalParams();
	userPrevent(true);
	getVars(settings);
	threeJsVariables.cloth.updateColor();
	setSelectionBoxesColors();
	getLordIconColors();
	debugOrbitControls();
	addWatermark();
	setInitialHtmlDirection(settings);
	mobileBuildingLabelsHideLogic();
	settingsData.isLandscape = window.matchMedia("(orientation: landscape)").matches;
	new EventBus();

	if (checkHash('showPrice'))
		config.crmProjectSettings.property.settings.displayPrice = 'button';
	if (checkHash('price'))
		config.crmProjectSettings.property.settings.displayPrice = 'show';
	if ((parseInt(getUrlParam('prepayment')) === 1))
		config.features.prepayment = true;
	if ((parseInt(getUrlParam('day-night-debug')) === 1))
		config.features.dayNight.debug = true;

	!BmbyMode.active && new UserAPI().send();
	//new Fullscreen().addBtn(UIRoot, 'body');
	Favorite.load();
	if (isUrlHasParam('reload')) {
		let secondsBetweenReloads = Math.abs(parseInt(getUrlParam('reload')));
		setInterval(() => {
			updateProjectAPIData();
		}, secondsBetweenReloads * 1000);
	}
	RaycastHandler(settings);
	if (!isMobile)
		rightNavigationBar();
	await getContactsDataFromAPI()
		.then((response) => {
			if (BmbyMode.active)
				return;
			config.contactWidget = response.find(item => item.title === 'contactWidget').crmData;
			config.consolto = response.find(item => item.title === 'consolto').crmData;
			config.schedulerId = response.find(item => item.title === 'schedulerId').crmData;

			menuInit(settings);
			chatsInit();
		});
	if (SalesPlane.canActivate())
		new SalesPlane();
	addMainScreenDisclaimer();
	new VideoPopUp();
	new RenderingLogo();
	langSwitcher(settings);
	if (config.features.weather.active && (!config.features.liteMode?.active || config.features.liteMode?.active && config.features.liteMode?.settings?.sky?.active))
		new DisplayOptions(UIRoot);
	const bottomNavBar = bottomNavBarInit();
	threeJsVariables.cssLabelManager.createButton(bottomNavBar);
	PointViewManager.init(bottomNavBar);
	compassInit(bottomNavBar);
	new CylinderBase();
	addLabelRenderContainer();
	poiIntersection();
	updateComponentsOnCanvasResize();
	widgetsInit(settings);
	Cluster.update();

	userPrevent(false);
	threeJsVariables.tasks.run();
	!BmbyMode.active && new PushNotifications().connect();
	new ScreenLogo(settings.general.logo);
	projectMode.LiteMode?.runProjectStartAdditionalFunctions();
	// projectMode.LiteMode?.rotor?.runLazyLoading();
	initForm(UIRoot);
	!isMobile && createStreetNames();
	addPoweredLogo();
	!isMobile && EnvironmentToggle.preloadOSM();

	if (config.features?.banners)
		new Banner(config.features.banners[0]);

	/**
	 *  Disable zoom on DOM elements
	 */

	let touchDist2;
	document.body.addEventListener('touchmove', (e) => {
		if (e.touches.length >= 2) {
			const dx = e.touches[0].screenX - e.touches[1].screenX;
			const dy = e.touches[0].screenY - e.touches[1].screenY;
			touchDist2 = Math.sqrt((dx * dx) + (dy * dy));

			if (touchDist2 > 70) {
				e.preventDefault();
			} else {
				return true;
			}
		}
	}, {passive: false});

	window.addEventListener('resize', onWindowResize, false);
	const resizeObserver = new ResizeObserver(() => {
		updateComponentsOnCanvasResize()
	});
	resizeObserver.observe(TRoot);
	checkAndSetScreenOrientation();

	projectMode.LiteMode?.resizeContainer();
	projectMode.AirMode.resize();
	projectMode.AirMode.update();

	lockScreenOrientation();

	setTimeout(() => autoRotateInit(), isMobile ? 3000 : 0);

	getGoogleAnalyticsData();
	getCommonAssets().then((response) => {
		settingsData.commonAssets = response.data;
		projectMode.FloorPlan.floorAmenities.settingsData = settingsData.commonAssets;
	});
	threeJsVariables.slicer.intro();

	// const cameraMarker = new CameraMarker('camera', threeJsVariables.perspectiveCamera, threeJsVariables.orbitControls);
	// const areaLimit = new ZoomArea('zoom');
	// threeJsVariables.miniMap.addMarker(cameraMarker);
	// threeJsVariables.miniMap.addMarker(areaLimit);
	// threeJsVariables.miniMap.computeBoundingBox();
	// cameraMarker.enabled = true;
	// threeJsVariables.miniMap.show();

	threeJsVariables.googleMiniMap.init();
	const controlsContainer = new BaseElement()
		.addClass('controls-nav-bar')
		.appendTo(TRoot)
		.DOMElement;
	
	new Joystick().create(controlsContainer);
	new SkyLineController(threeJsVariables.orbitControls).ui(controlsContainer);
	new ConfigInformer();
	!BmbyMode.active && showSoldApartmentsFromCurrentDay('-7');
	//pwa.show();
	// projectMode.LiteMode?.rotor?.runLazyLoading();
	setTimeout(() => {
		if (settingsData.activeViewMode === ViewMode.Orbit) {
			projectMode.LiteMode?.sceneVisibility(false);
		}
	},100);
	
	if (isWeb) {
		setTimeout(() => {
			const analyzation = new PerformanceAnalyzation();
			analyzation.callback = (averageFPS) => {
				if (averageFPS <= 25) {
					const lowPerformance = localStorage.getItem('lowPerformance');
					const hasAirModePanoramas = Object.keys(projectMode.AirMode.params.panoramas).length;
					if (!lowPerformance && hasAirModePanoramas && !projectMode.AirMode.active) {
						new ConfirmMessage('lowPerformanceMessage',(answer) => {
							if (answer === 'Agree') {
								localStorage.setItem('lowPerformance','1');
								window.location.reload(true);
							}
						});
					}
				}
			};
		},5000);
	}
}

function addMainScreenDisclaimer() {
	if (config.crmProjectSettings.general?.disclaimer)
		new Disclaimer(TRoot, config.crmProjectSettings.general?.disclaimer, 'disclaimer__main-screen');
}

export function renderUpdateValuesOnDemand(value = false) {
	if (settingsData.stopRender !== value && !settingsData.blockRenderState) {
		settingsData.stopRender = value;

		if (value) {
			console.warn('-=RENDER STOPPED=-');
		} else {
			console.warn('-=RENDER STARTED=-');
			settingsData.last_interaction = Date.now();
		}
	}
}

let onWindowResizeTimeout;

async function onWindowResize() {
	if (settingsData.stopWindowResizeEvents)
		return;

	if (isMobile && settingsData.activeModeSwitching) {
		clearTimeout(onWindowResizeTimeout);
		UnitCardClass.closeMobileCard();
		onWindowResizeTimeout = setTimeout(() => onWindowResize(), 100);
		return;
	}

	const activeMenu = getActiveMenuData();
	if (activeMenu === '3dModel' || activeMenu === 'search') {
		renderUpdateValuesOnDemand(false);
	} else {
		renderUpdateValuesOnDemand(true);
	}
	await fitModelInViewport(true);
	buildingsLabelResize();
	rightNavMenuZIndexChange();
	checkAndSetScreenOrientation();
	additionalMenuToggle();
	setWidthOfApplyNow();
	resizeGallery();

	setCSSVar(
		'--optionsCardPlansBoxWidth',
		`${Math.round(new GetElement('.options-card__plans-box').width)}px`
	);

	// if (isMobile) {
	// 	collapseFilterHeader();
	// 	if (settingsData.isLandscape) {
	// 		document.querySelector('.search__container-bottom')?.classList.remove('hidden');
	// 		document.querySelector('.search__title-wrapper')?.classList.remove('hidden');
	// 		document.querySelector('.search__checker')?.classList.remove('hidden');
	// 		document.querySelector('.search__result-count')?.classList.add('hidden');
	// 		if (!document.querySelector('.search__advanced-search:not(.hidden)'))
	// 			document.querySelector('.search__top-wrapper')?.classList.add('hidden');
	// 	} else {
	// 		searchSwipeUpHandler();
	// 	}
	// }


	setTimeout(() => {
		lockScreenOrientation();

		moveElements();
		setMinAndMaxControlsDistance();
		resizeOrbitPoiCard();
		fitModelInViewport(true);
		panoramaOrbitResize();
		poiOrientationHandler();
		DisplayOptions.displayOptionsVisibility('update');
		projectMode.LiteMode?.resizeContainer();
	}, 100);

	const compareCards = document.querySelector(`.compare-block`);
	if (compareCards)
		setWidthOfCardDependingOnMenu(compareCards);

	setOptionsCardButtonsWidthIntoCssVar();
	if (document.getElementById('building-switcher'))
		setParametersDependsOnCanvasArea('building-switcher');
	if (document.querySelector('.display-options')?.classList.contains('display-options--expanded'))
		DisplayOptions.hideDisplayOptions();

	if (isOptionsCardOpened()) {
		setPlansBlockBoundaries();
		if (isMobile)
			recreateBlockWhenLangSwitch();
		UnitCardClass.applyOptionsCardRules();
		if (cardsData.cardMode.isAmenities)
			setOptionsCardDataHeightInCssVar();
	}

	setSearchContainerMaxHeight();
	McID.resizeHandler();
	if (components?.contactWidget)
		components.contactWidget.positionRecalc();
}

function checkAndSetScreenOrientation() {
	const currentOrientation = window.matchMedia("(orientation: landscape)").matches;
	if (currentOrientation !== settingsData.isLandscape) {
		settingsData.isLandscape = window.matchMedia("(orientation: landscape)").matches;
		if (isMobile)
			analytics('orientation', settingsData.isLandscape ? 'landscape' : 'portrait');
	}

}

function updateControls() {
	if (cameraAnimationActive())
		return;

	const orbitControlsTarget = controls.target;
	if (!AirMode.blockMainControlsUpdate) {
		controls.update();
		trackballControls.target.set(orbitControlsTarget.x, orbitControlsTarget.y, orbitControlsTarget.z);
		trackballControls.update();
	}
}

function addDocumentProperties() {
	const {projectTitle, cdnRepository, projectFolder} = config;
	document.title = projectTitle;
	// const favicon = createHtmlElement(document.head, '', 'link', []);
	// favicon.setAttribute('rel', 'shortcut icon');
	// favicon.setAttribute('type', 'image/png');
	// favicon.href = `${cdnRepository}/${projectFolder}/resources/img/favicon.png?v=${Cloudflare.version}`;

	new BaseElement('link')
		.setAttributes({
			'rel': 'shortcut icon',
			'type': 'image/png',
			'href': `${cdnRepository}/${projectFolder}/resources/img/favicon.png?v=${Cloudflare.version}`
		})
		.appendTo(document.head);
}

// let fps_last_check = performance.now();
// let fps_average = 0;
// let fps_check_count = 0;
// let last_time = 0;
// let last_time_check = 0;
// let fps_30 = 1000/30; //
// let fps_60 = 1000/60; //
// let max_fps = fps_30; // ограничение кадров в секунду, можно для мобилок сделать 30fps

// set errorTarget before flyIsComplete.
// flag is using to prevent infinite setting and rendering
let isErrorTargetSet = false;
let originErrorTarget = null;
if (!isMobile) {
	originErrorTarget = threeJsVariables.tilesRenderer?.errorTarget;
	if (threeJsVariables.tilesRenderer?.hasOwnProperty('initialErrorTarget')) {
		threeJsVariables.tilesRenderer.errorTarget = threeJsVariables.tilesRenderer.initialErrorTarget;
	} else {
		isErrorTargetSet = true;
	}
}

let delta = 0;

// let now = 0;

export function animate() {
	threeJsVariables.renderer.info.reset();
	// now = performance.now();
	delta = clock.getDelta();
	elapsedTime = clock.elapsedTime;

	// проверяем частоту кадров
	// fps_average = fps_average + (now - last_time_check);
	// fps_check_count = fps_check_count + 1;
	// last_time_check = now;

	settingsData.renderAnim = requestAnimationFrame(animate);

	// if (delta < max_fps) {
	//     return;
	// } else {
	//     if ((now - fps_last_check)>1000.0){
	//         fps_last_check = now;
	//         fps_average = fps_average / fps_check_count;
	//         if (fps_average<fps_30) {
	//             max_fps = fps_60
	//         } else {
	//             max_fps = fps_30
	//         }
	//         fps_average = 0;
	//         fps_check_count = 0
	//     }
	// }
	// //----------------------
	// last_time = now;

	if (settingsData.slideShowed && !isErrorTargetSet && !isMobile) {
		threeJsVariables.tilesRenderer.errorTarget = originErrorTarget;
		settingsData.needsRerender = true;
		isErrorTargetSet = true;
	}
	TWEEN.update();

	if (settingsData.slideShowed)
		cameraUpdate(delta);

	if (threeJsVariables.background && !config.features.privateHouseMode && !isCylinderDisplayModeEqual('show all')) {
		if (settingsData.activeViewMode === ViewMode.Cylinder || projectMode.LiteMode.animateSky) {
			let a = threeJsVariables.background;
			a.rotation.y = a.rotation.y - 0.005 * delta;
		}
	}

	if (!settingsData.stopRender && ((Date.now() - settingsData.last_interaction) >= settingsData.stopTimeRender)) {
		renderUpdateValuesOnDemand(true);
	}

	if (
		(settingsData.resolveTilesUpdate && settingsData.needsRerender && settingsData.activeViewMode === ViewMode.Orbit) ||
		(settingsData.needsRerender && isCylinderDisplayModeEqual('show all')) ||
		(settingsData.needsRerender && config.features.privateHouseMode)) {
		renderLoop();
	}

	if (!settingsData.stopRender) {
		updateControls();
		Weather.render(elapsedTime);
		updateLabelsRenderer();
		// flatLabelResize();
		projectMode.LiteMode?.updateTime(delta);
		OSMEnv.update(elapsedTime);
		PublicLayers.animate(delta);
		Environment.animate(delta);
		animationMixerUpdate(delta);
		if (Vantages.isActive()) {
			Vantages.render(delta);
		} else {

			threeJsVariables.composer.render(delta);
		}
		threeJsVariables.fps.update();

		if (threeJsVariables.stats !== null)
			threeJsVariables.stats.update();

	} else {
		settingsData.isIntersection = false;
		autoRotateTimerAction('cancel');
	}
}

export function updateRaycaster() {
	if (projectMode.LiteMode.isActive()) {
		if (projectMode.LiteMode.isVisible()) {
			threeJsVariables.raycaster.setFromCamera(threeJsVariables.mouse, projectMode.LiteMode.camera);
			projectMode.LiteMode.updateDepthPosition();
		} else {
			threeJsVariables.raycaster.setFromCamera(threeJsVariables.mouse, threeJsVariables.perspectiveCamera);
		}
	} else {
		threeJsVariables.raycaster.setFromCamera(threeJsVariables.mouse, threeJsVariables.perspectiveCamera);
	}
	checkIntersection();
}

export function updateLabelsRenderer() {
	if (threeJsVariables.labelRenderer) {
		if (projectMode.LiteMode.isActive() && projectMode.LiteMode.isVisible()) {
			threeJsVariables.labelRenderer.render(threeJsVariables.scene, projectMode.LiteMode.camera);
		} else {
			threeJsVariables.labelRenderer.render(threeJsVariables.scene, threeJsVariables.perspectiveCamera);
		}
	}
}

export function getCanvasWidthDiff() {
	const {innerWidth} = window;
	const canvas = threeJsVariables.renderer.getSize(new Vector2());

	if (isMobile) {
		return new Vector2(0, 0);
	} else if (isDesktop) {
		return new Vector2(0, 0);
	} else {
		if (getCurrentLangDirection() === 'ltr') {
			return new Vector2(innerWidth - canvas.x, canvas.y);
		} else {
			return new Vector2(0, 0);
		}
	}
}

// export function updateLabels() {
//     return;
//     // const canvasSize = threeJsVariables.renderer.getSize(new Vector2());
//     if (Object.keys(threeJsVariables.labelRenderer).length) {
//         // threeJsVariables.labelRenderer.setSize(canvasSize.x, canvasSize.y);
//         const langDirection = getCurrentLangDirection();
//         switch (langDirection) {
//             case 'rtl':
//                 threeJsVariables.labelRenderer.domElement.style.right = '0';
//                 break;
//             case 'ltr':
//                 threeJsVariables.labelRenderer.domElement.style.left = '0';
//                 break;
//         }
//     }
// }

function addLabelRenderContainer() {
	const rootHeight = TRoot.getBoundingClientRect().height;
	const rootWidth = TRoot.getBoundingClientRect().width;
	threeJsVariables.labelRenderer = new CSS2DRenderer();
	threeJsVariables.labelRenderer.setSize(rootWidth, rootHeight);
	threeJsVariables.labelRenderer.domElement.addEventListener('click', (e) => {
		cssPoiHandler(e);
	});

	new BaseElement()
		.addAttribute('id', 'three_d_css')
		.appendTo(TRoot)
		.appendElement(threeJsVariables.labelRenderer.domElement);

	return threeJsVariables.labelRenderer;
}

export const applySafariFixForFlatLabels = () => {
	const three_d_css = document.getElementById('three_d_css');
	if (!Boolean(three_d_css))
		return;

	const rtl = document.documentElement.getAttribute('dir') === 'rtl';
	if (isSafari && !rtl)
		three_d_css.classList.add('safari');
}

export const removeSafariFixForFlatLabels = () => {
	const three_d_css = document.getElementById('three_d_css');
	if (!Boolean(three_d_css))
		return;

	three_d_css.classList.remove('safari');
}

// const doubleClickHandler = (e) => {
//     e.preventDefault();
//     // console.log('window: ', settingsData.doubleClick)
//     settingsData.doubleClick = true;
//     setTimeout(() => {settingsData.doubleClick = false}, 1000)
// }

// export function checkTabletMode () {
//     // const correctViewPort = window.innerWidth  >= 768 && window.innerWidth  <= 1024 && window.innerHeight >= 850 && window.innerHeight <= 1366;
//     // const correctUserAgent = navigator.userAgent.match(/Tablet|iPad/i);
//     //
//     // return correctUserAgent && correctViewPort;
//
//     return false;
// }

// export function rendererAnimationPause(value) {
//     return;
//     if (value) {
//         setTimeout(() => {
//             settingsData.stopRender = value;
//         }, 1000);
//     } else {
//         settingsData.stopRender = value;
//     }
// }

// export function updateRenderer() {
//     //threeJsVariables.renderer.render(threeJsVariables.scene, threeJsVariables.perspectiveCamera); // not stop renderer
// }

// function waitAnimations () {
//     if (settingsData.animationsList.length === 0){
//         return;
//     }
//
//     userPrevent(true);
//
//     settingsData.activeViewMode === ViewMode.FloorPlan && flatLabelsRemove();
//
//     Promise.all(settingsData.animationsList)
//         .then(()=>{
//             settingsData.animationsList = [];
//             userPrevent(false);
//             settingsData.activeViewMode === ViewMode.FloorPlan && flatLabelsUpdate(settingsData.currentFloor);
//         })
// }

// export const manager = new LoadingManager();
// manager.onStart = function (url, itemsLoaded, itemsTotal) {
// };
//
// manager.onProgress = (url, itemsLoaded, itemsTotal) => {
//     // console.log(`itemsTotal / itemsLoaded = ${itemsTotal} / ${itemsLoaded}`);
//     settingsData.totalPercent = (itemsLoaded / itemsTotal * 100);
//     console.log(settingsData.totalPercent,url);
// };
//
//
// manager.onLoad = async () => {
//     //await loadCylinderGrid();
//     // loadCylinderGrid();
//     // if (config.cesiumEnvironment.envType !== EnvironmentTypes.TilesEnv){
//     //removePreloader();
//     await startProjectWithError();
//     projectMode.Cylinder = new Cylinder();
//     projectMode.FloorPlan = new FloorPlan();
//
//     // }
// };

// const cursorOffset = {
//     left : 20,
//     top  : -15
// };
//
// const cursor = document.getElementById('cursor');
//
// document.getElementById('c').addEventListener('mousemove',function(e) {
//     if (settingsData.customCursor){
//         e.target.style.cursor = 'none';
//         cursor.style.left = (e.pageX - cursorOffset.left) + 'px';
//         cursor.style.top = (e.pageY - cursorOffset.top) + 'px';
//         cursor.style.display = 'block';
//     } else {
//         cursor.style.display = 'none';
//     }
// }, false);
